import React from 'react';
import { Line } from 'react-chartjs-2';

const KPIs = ({ 
  indicatorsForSelectedDate,
  selectedDate,
  colorFromString,
  getMiniChartData,
  onShowDetails
}) => {

  const totalValor = indicatorsForSelectedDate.reduce((sum, item) => sum + parseInt(item.valor, 10), 0);

  return (
    <div>
      <div className="row mb-4">
        {indicatorsForSelectedDate.length > 0 ? (
          <>
            {indicatorsForSelectedDate.map((item, index) => (
              <div className="col-md-2" key={index}>
                <div 
                  className="card text-center shadow-sm h-100" 
                  style={{ borderTop: `4px solid ${colorFromString(item.indicador)}`, cursor: 'pointer' }}
                  onClick={() => onShowDetails(item.indicador, selectedDate)}
                  title={`Ver detalle de productividad para ${item.indicador}`}
                >
                  <div className="card-body">
                    <h5 className="card-title" style={{ minHeight: '3em' }}>{item.indicador}</h5>
                    <p className="card-text fs-1 fw-bold">{item.valor}</p>
                    <div style={{ height: '50px', marginBottom: '1rem' }}>
                      <Line {...getMiniChartData(item.indicador)} />
                    </div>
                    <p className="card-text"><small className="text-muted">{new Date(selectedDate).toLocaleDateString('es-AR', { timeZone: 'UTC' })}</small></p>
                  </div>
                </div>
              </div>
            ))}
            <div className="col-md-2">
              <div className="card text-center shadow-sm h-100" style={{ borderTop: '4px solid black', backgroundColor: '#f8f9fa' }}>
                <div className="card-body">
                  <h5 className="card-title" style={{ minHeight: '3em' }}>Total</h5>
                  <p className="card-text fs-1 fw-bold">{totalValor}</p>
                  <div style={{ height: '50px', marginBottom: '1rem' }}>
                  </div>
                  <p className="card-text"><small className="text-muted">{new Date(selectedDate).toLocaleDateString('es-AR', { timeZone: 'UTC' })}</small></p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="col">
              <div className="card shadow-sm">
                  <div className="card-body">
                      <p className="text-center mb-0">No hay datos para la fecha seleccionada.</p>
                  </div>
              </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default KPIs;
